import { Link } from 'react-router-dom';
import { mockArticles } from '@/mocks/articles';

export default function FeaturedSection() {
  const featured = mockArticles.filter((a) => a.featured).slice(0, 3);

  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            精选推荐
          </h2>
          <p className="mt-1 text-sm text-foreground-600">
            编辑团队为你精心挑选的优质内容
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {featured.map((article, index) => {
          const categoryLabel = getCategoryLabel(article.category);
          return (
            <article key={article.id} className="group cursor-pointer">
              <Link to={`/article/${article.id}`} className="block">
                <div className="relative overflow-hidden rounded-lg aspect-[16/10] mb-4">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 rounded-md bg-background-50/90 text-xs font-medium text-foreground-700 backdrop-blur-sm">
                      {categoryLabel}
                    </span>
                  </div>
                </div>
                <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span>{article.author}</span>
                  <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
                  <span>{article.publishedAt}</span>
                  <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
                  <span>{article.readTime}</span>
                </div>
              </Link>
            </article>
          );
        })}
      </div>
    </section>
  );
}

function getCategoryLabel(slug: string): string {
  const map: Record<string, string> = {
    'japan-drama': '日剧',
    'korea-drama': '韩剧',
    'japan-movie': '日本电影',
    'korea-movie': '韩国电影',
    'kpop': 'K-POP',
    'jpop': 'J-POP',
    'variety': '综艺',
    'star': '明星',
  };
  return map[slug] || slug;
}